import Vue from 'vue'
import Login from './Login.vue'
import router from "./router";

// FONTAWESOME
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLeaf, faUser, faKey, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faLeaf, faUser, faKey, faSpinner);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(Login)
}).$mount('#app')
